import {
  FETCH_ORDENES,
  FETCH_ORDEN,
  EDIT_ORDEN,
  FETCH_ORDENES_EN_VERDE,
  FETCH_CLIENTE,
  LOADING_ORDENES,
  SET_FILTRO_ORDENES,
  FETCH_ORDENES_ENCABEZADO,
  RESET_ORDENES
} from './types';
import {
  getOrden,
  fetchOrdenesParams,
  fetchOrdenesEnVerdeParams,
  fetchOrdenesEncabezadoParams,
  fetchMotivosSolicitudAnulacionApi,
  getFacturaOrdenesApi
} from "../api/axios";

let lastOrdenesEncabezadoKey = null;
let lastOrdenesEncabezadoAt = 0;
let lastOrdenesEncabezadoData = null;

const normalizeOptionalSellerParam = (params) => {
    if (!params || typeof params !== 'object') {
        return params;
    }

    ['idSeller', 'IdSeller'].forEach((key) => {
        if (!Object.prototype.hasOwnProperty.call(params, key)) {
            return;
        }

        const rawValue = params[key];
        const trimmedValue = typeof rawValue === 'string' ? rawValue.trim() : rawValue;

        if (trimmedValue === '' || trimmedValue == null) {
            delete params[key];
            return;
        }

        const numericValue = Number(trimmedValue);
        if (Number.isNaN(numericValue) || numericValue <= 0) {
            delete params[key];
        }
    });

    return params;
};

const normalizedElementosOrdenes = (ordenes) => {
    const elementos = ordenes?.elementos ?? ordenes?.paginateOrdenes?.content ?? ((ordenes?.idOrden != null || ordenes?.IdOrden != null) ? [ordenes] : []);

    const normalizedElementos = elementos.map(orden => ({
        idOrden: orden?.idOrden ?? orden.IdOrden ?? null,
        idReferencia: orden?.idReferencia ?? orden?.IdReferencia ?? null,
        fecha: orden?.fecha ?? orden?.Fecha ?? "",
        anulacionMegatone: {
            anulado:
                orden?.anulacionMegatone?.anulado ??
                orden?.AnulacionMegatone?.Anulado ??
                orden?.AnulacionMegatone?.anulado ??
                orden?.anulacionMegatone?.Anulado ??
                null,
            motivoAnulacion:
                orden?.anulacionMegatone?.motivoAnulacion ??
                orden?.AnulacionMegatone?.MotivoAnulacion ??
                orden?.AnulacionMegatone?.motivoAnulacion ??
                orden?.anulacionMegatone?.MotivoAnulacion ??
                null
        },
        montoComision: orden?.montoComision ?? 0,
        montoVenta: orden?.montoVenta ?? 0,
        idVendedorBoca: orden?.idVendedorBoca ?? null,
        productos: orden?.productos?.map(producto => ({
            skuMarket: producto?.codProducto ?? producto?.skuMarket ?? "",
            sellerSku: producto?.skuSeller ?? producto?.sellerSku ?? "",
            precioUnitario: producto?.precioUnitario ?? 0,
            titulo: producto?.titulo ?? "",
            imagenPrincipal: producto?.imagenPrincipal ?? null,
            cantidad: producto?.cantidad ?? null,
            ...producto
        })) ?? [],
        cliente: normalizeCliente(orden),
        entrega: orden?.entrega ?? orden?.Entrega ?? (orden?.tipoEntrega ? {tipoEntrega: orden?.tipoEntrega} : { tipoEntrega: { codigo: 0, descripcion: "" } }),
        estado: normalizeEstado(orden),
        plataforma: orden?.tipoPlataforma ? {
            codigo: orden?.tipoPlataforma?.codigo ?? 0,
            descripcion: orden?.tipoPlataforma?.descripcion ?? ""
        } : (orden?.plataforma ?? { codigo: 0, descripcion: "" }),
        pago: normalizePago(orden),
        seller: orden?.seller ? {
            codigo: orden.seller?.codigo ?? orden.seller?.idSeller ?? 0,
            descripcion: orden.seller?.descripcion ?? orden.seller?.razonSocial ?? "",
            urlLogo: orden.seller?.urlLogo ?? null
        } : (orden?.Seller ? {
            codigo: orden.Seller?.IdSeller ?? 0,
            descripcion: orden.Seller?.RazonSocial ?? "",
            urlLogo: orden.Seller?.UrlLogo ?? null
        } : { codigo: 0, descripcion: "", urlLogo: null })
    }))

    return normalizedElementos;
}

const normalizeCliente = (orden) => {
    const cliente = orden?.cliente ?? orden?.Cliente ?? orden?.comprador ?? orden?.Comprador ?? {};
    return {
        nombre: cliente?.nombre ?? cliente?.Nombre ?? "",
        apellido: cliente?.apellido ?? cliente?.Apellido ?? "",
        email: cliente?.email ?? cliente?.Email ?? "",
        documento: cliente?.dni ?? cliente?.Dni ?? cliente?.documento ?? cliente?.Documento ?? 0,
        tipoDocumento: cliente?.tipoDocumento ?? cliente?.TipoDocumento ?? "DNI",
        calle: cliente?.calle ?? cliente?.Calle ?? "",
        numero: cliente?.numero ?? cliente?.Numero ?? "",
        piso: cliente?.piso ?? cliente?.Piso ?? "",
        departamento: cliente?.departamento ?? cliente?.Departamento ?? "",
        codigoPostal: cliente?.codigoPostal ?? cliente?.CodigoPostal ?? "",
        localidad: cliente?.localidad ?? cliente?.Localidad ?? "",
        provincia: cliente?.provincia ?? cliente?.Provincia ?? "",
        telefono: cliente?.telefono ?? cliente?.Telefono ?? ""
    };
}

const normalizeEstado = (orden) => {
    const est = orden?.estadoOrden ?? orden?.estado ?? orden?.Estado;
    const estados = Array.isArray(est) ? est : [];
    return estados.map((estado) => ({
        idEstado: Number(estado?.idEstado ?? estado?.IdEstado ?? 0),
        descripcion: estado?.descripcion ?? estado?.Descripcion ?? "",
        fecha: estado?.fecha ?? estado?.Fecha ?? "",
        comprobante: estado?.comprobante ?? estado?.Comprobante ?? estado?.archivo ?? estado?.Archivo ?? ""
    }));
};

const normalizePago = (orden) => {
    const pago = orden?.pago ?? orden?.Pago ?? {};
    const rawCupones = pago?.cupones ?? pago?.Cupones ?? [];
    return {
        ...pago,
        cuotas: pago?.cuotas ?? pago?.Cuotas ?? 0,
        tarjeta: pago?.tarjeta ?? pago?.Tarjeta ?? "",
        banco: pago?.banco ?? pago?.Banco ?? "",
        medioPago: pago?.medioPago ?? pago?.MetodoPago ?? pago?.metodoPago ?? "",
        cupones: Array.isArray(rawCupones) ? rawCupones.map((c) => ({
            ...c,
            idTipoEntidad: c?.idTipoEntidad ?? c?.IdTipoEntidad,
            metodoPago: c?.metodoPago ?? c?.MetodoPago ?? "",
            nroPlan: c?.nroPlan ?? c?.NroPlan ?? 0,
            cuotas: c?.cuotas ?? c?.Cuotas ?? 0,
            tarjeta: c?.tarjeta ?? c?.Tarjeta ?? "",
            banco: c?.banco ?? c?.Banco ?? "",
            montoCuota: c?.montoCuota ?? c?.MontoCuota ?? 0,
            recargo: c?.recargo ?? c?.Recargo ?? 0,
            idTransaccion: c?.idTransaccion ?? c?.IdTransaccion ?? c?.IdTrasaccion ?? "",
            primerosSeisDigitos: c?.primerosSeisDigitos ?? c?.PrimerosSeisDigitos ?? "",
            ultimosCuatroDigitos: c?.ultimosCuatroDigitos ?? c?.UltimosCuatroDigitos ?? "",
            nroCupon: c?.nroCupon ?? c?.NroCupon ?? "",
            adquiriente: c?.adquiriente ?? c?.Adquiriente ?? "",
            autorizacion: c?.autorizacion ?? c?.Autorizacion ?? ""
        })) : []
    };
};

const extractComprobantesOrden = (responseData, idEstadoFallback) => {
  const data = responseData ?? {};

  if (Array.isArray(data?.comprobantes)) return data.comprobantes;
  if (Array.isArray(data?.Comprobantes)) return data.Comprobantes;
  if (Array.isArray(data?.elementos)) return data.elementos;
  if (Array.isArray(data?.Elementos)) return data.Elementos;
  if (data?.archivo || data?.Archivo) {
    return [{ idEstado: idEstadoFallback, archivo: data?.archivo ?? data?.Archivo }];
  }
  return [];
};

const getArchivoByEstadoPreferido = (comprobantes, idEstado) => {
  const getIdEstado = (item) => Number(item?.idEstado ?? item?.IdEstado);
  const getArchivo = (item) =>
    item?.archivo ??
    item?.Archivo ??
    item?.comprobante ??
    item?.Comprobante ??
    "";

  const comprobanteEstado = comprobantes.find((item) => getIdEstado(item) === Number(idEstado));
  const comprobanteFallbackAnulado =
    Number(idEstado) === 5
      ? comprobantes.find((item) => getIdEstado(item) === 2)
      : null;
  const comprobanteCualquiera = comprobantes.find((item) => Boolean(getArchivo(item)));

  return (
    getArchivo(comprobanteEstado) ||
    getArchivo(comprobanteFallbackAnulado) ||
    getArchivo(comprobanteCualquiera) ||
    ""
  );
};

export const fetchOrdenes = (request) => async dispatch => { // SE LLAMA EN ExportarOrdenes PERO NO SE UTILIZA
    dispatch({
        type: LOADING_ORDENES,
        payload: true
    });

    const requestParse = { ...request }

    let array = fetchOrdenesParams(requestParse);
    array.then((ordenes) => {
        const payload = {
            elementos: normalizedElementosOrdenes(ordenes),
            montoVentasTotal: ordenes?.montoTotalVentas ?? 0,
            montoTotalVentasAnuladas: ordenes?.montoTotalVentasAnuladas ?? 0,
            montoComisionTotal: ordenes?.montoTotalComision ?? 0,
            cantidadTotal: ordenes?.total ?? 0,
            cantidadPagina: ordenes?.totalPages ?? 0
        }
        dispatch({
            type: FETCH_ORDENES,
            payload
        });

        dispatch({
            type: LOADING_ORDENES,
            payload: false
        });
    })
}

export const fetchOrdenesEncabezado = (request) => async dispatch => {
    dispatch({
        type: LOADING_ORDENES,
        payload: true
    });

    const requestParse = { ...request }

    const params = {
        ...requestParse,
        page: requestParse.numeroPagina,
        pageSize: requestParse.cantidadPagina,
    };
    delete params.numeroPagina;
    delete params.cantidadPagina;
    // Campos de UI que no deben viajar al backend en el querystring.
    delete params.seller;
    delete params.estado;
    delete params.tipoOrden;
    delete params.idTipoOrden;

    if (Object.prototype.hasOwnProperty.call(params, 'TipoOrden')) {
        const tipoOrden = Number(params.TipoOrden);
        params.TipoOrden = Number.isFinite(tipoOrden) && tipoOrden > 0 ? tipoOrden : 0;
    }
    normalizeOptionalSellerParam(params);

    const requestKey = JSON.stringify(params);
    const now = Date.now();
    const cacheWindowMs = 7000;
    if (requestKey === lastOrdenesEncabezadoKey && lastOrdenesEncabezadoData && (now - lastOrdenesEncabezadoAt) < cacheWindowMs) {
        return lastOrdenesEncabezadoData;
    }

    fetchOrdenesEncabezadoParams(params).then((ordenes) => {
        const payload = {
            elementos: normalizedElementosOrdenes(ordenes),
            montoVentasTotal: ordenes?.montoTotalVentas ?? 0,
            montoTotalVentasAnuladas: ordenes?.montoTotalVentasAnuladas ?? 0,
            montoComisionTotal: ordenes?.montoTotalComision ?? 0,
            cantidadTotal: ordenes?.paginateOrdenes?.total ?? 0,
            cantidadPagina: ordenes?.paginateOrdenes?.totalPages ?? 0,
            page: ordenes?.paginateOrdenes?.page,
            pageSize: ordenes?.paginateOrdenes?.pageSize,
        }
        dispatch({
            type: FETCH_ORDENES_ENCABEZADO,
            payload
        });

        lastOrdenesEncabezadoAt = now;
        lastOrdenesEncabezadoKey = requestKey;
        lastOrdenesEncabezadoData = payload;

        dispatch({
            type: LOADING_ORDENES,
            payload: false
        });
    }).catch((error) => {
        dispatch({
            type: FETCH_ORDENES_ENCABEZADO,
            payload: []
        });
        dispatch({
            type: LOADING_ORDENES,
            payload: false
        });
    });
}

export const fetchOrdenesEnVerde = (request) => async (dispatch, getState) => {
  dispatch({
    type: LOADING_ORDENES,
    payload: true
  });

  const requestParsed = { ...request };
  const { userType, codProv, userId } = getState().general || {};
  // Proveedor: codProv e idUsuario (la API suele filtrar por uno o ambos; el BFF los fuerza desde el JWT).
  if (userType?.isProveedor) {
    if (codProv !== null && codProv !== undefined && codProv !== '') {
      requestParsed.codProv = codProv;
    }
    if (userId && Number(userId) > 0) {
      requestParsed.idUsuario = Number(userId);
    }
  }

  let array = fetchOrdenesEnVerdeParams(requestParsed);
  array.then((ordenesEnVerde) => {
    dispatch({
      type: FETCH_ORDENES_EN_VERDE,
      payload: ordenesEnVerde
    });

    dispatch({
      type: LOADING_ORDENES,
      payload: false
    });
  }).catch((error) => {
    console.error("Error fetching ordenes:", error);
    dispatch({
      type: LOADING_ORDENES,
      payload: false
    });
  })
}

export const fetchOrden = (id, idUsuario) => async dispatch => {
    dispatch({
        type: LOADING_ORDENES,
        payload: true
    });

    getOrden(id, idUsuario).then((ordenes) => {
        const payload = normalizedElementosOrdenes(ordenes)
        dispatch({
            type: FETCH_ORDEN,
            payload: payload[0]
        });

        dispatch({
            type: LOADING_ORDENES,
            payload: false
        });
    })
}

export const fetchDatosComprador = (id, idUsuario) => async dispatch => {
  dispatch({
    type: LOADING_ORDENES,
    payload: true
  });

  let ordenNew = {
    "nombre": "",
    "apellido": "",
    "tipoDocumento": "",
    "documento": 0,
    "domicilio": "",
    "numeroDomicilio": "",
    "piso": "",
    "departamento": "",
    "codigoPostal": "",
    "localidad": "",
    "provincia": "",
    "codigoProvincia": "",
    "email": "",
    "prefijoTelefono": "",
    "telefono": "",
    "prefijoCelular": "",
    "numeroCelular": "",
    "sexo": "",
    "situacionIva": "",
    "cuit": ""
  }

  if (id != undefined) {
    let orden = getOrden(id, idUsuario);
    orden.then((orden) => {
      dispatch({
        type: FETCH_CLIENTE,
        payload: orden.elementos[0].cliente
      });

      dispatch({
        type: LOADING_ORDENES,
        payload: false
      });
    })
  } else {
    dispatch({
      type: FETCH_CLIENTE,
      payload: ordenNew
    });

    dispatch({
      type: LOADING_ORDENES,
      payload: false
    });
  }
}

export const editDatosComprador = (orden) => dispatch => {
  dispatch({
    type: FETCH_CLIENTE,
    payload: orden
  });
}

export const editOrden = (orden) => dispatch => {
  dispatch({
    type: EDIT_ORDEN,
    payload: orden
  });
}

export const setFiltroOrdenes = (filtro) => dispatch => {
  dispatch({
    type: SET_FILTRO_ORDENES,
    payload: filtro
  });
}

export const resetOrdenes = () => dispatch => {
  dispatch({
    type: RESET_ORDENES,
    payload: []
  });
}

export const fetchMotivosSolicitudAnulacion = async () => {
  const result = await fetchMotivosSolicitudAnulacionApi();
  const motivos = result?.motivosSolicitudAnulacion ?? result?.MotivosSolicitudAnulacion ?? result?.motivosSolicitud ?? result?.MotivosSolicitud ?? result?.motivos ?? result?.Motivos;
  return {
    ...result,
    motivosSolicitudAnulacion: motivos
  }
}

export const getFacturaOrdenes = async (idOrden, idEstado) => {
  const queryStates = [null, Number(idEstado), 2, 5, 1, 0]
    .filter((v, idx, arr) => (v === null || Number.isFinite(v)) && arr.indexOf(v) === idx);

  for (let index = 0; index < queryStates.length; index += 1) {
    const queryState = queryStates[index];
    const query = queryState === null
      ? `IdOrden=${idOrden}`
      : `IdOrden=${idOrden}&IdEstado=${queryState}`;

    try {
      const response = await getFacturaOrdenesApi(query);
      const fallbackEstado = queryState === null ? idEstado : queryState;
      const comprobantes = extractComprobantesOrden(response?.data, fallbackEstado);
      const archivo = getArchivoByEstadoPreferido(comprobantes, idEstado);
      const normalized = typeof archivo === "string" ? archivo.trim() : "";
      const isPdfBase64 = normalized.length >= 80 && normalized.startsWith("JVBERi0");
      if (isPdfBase64) {
        return normalized;
      }
    } catch {
      // Intentar con el siguiente IdEstado de la lista.
    }
  }

  throw new Error("No se encontró comprobante para la orden.");
};
